import { useEffect } from "react";
import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";


const MoleculeSelectBox = ({ label, tooltip, selectedKey = 0, lsKeyValue = {}, onChange, disable = false }) => {
    const uniqueId = uuidv4();
    return (
        <Col className="text-start">
            <Form.Group controlId={`selectbox-${uniqueId}`} className="d-flex align-items-start align-items-center">
                {/* Icon Info với Tooltip */}
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{tooltip}</Tooltip>}
                >
                    <InfoCircle className="me-1 mb-1 text-primary" style={{ cursor: "pointer", fontSize: "16px", minWidth: "16px" }} />
                </OverlayTrigger>
                <span className="text-nowrap me-2">{label}</span>
                <Form.Select
                    // style={{ width: "50%" }}
                    disabled={disable}
                    value={selectedKey}
                    onChange={(e) => {
                        if (onChange != null) onChange(e.target.value);
                    }}>
                    {Object.entries(lsKeyValue).map(([key, value]) => (
                        <option key={key} value={key}>
                            {value}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
        </Col>
    );
};

export default MoleculeSelectBox
